import {
    FETCH_GROUPED_TRAINERS,
    FETCH_TRAINER,
    FETCH_TRAINER_COURSE_MONTHLY_STATS,
    POST_TRAINER,
    PATCH_TRAINER,
    DELETE_TRAINER,
    WECHAT_UNBIND_TRAINER,
} from './types';

export default {
    [FETCH_GROUPED_TRAINERS](state, payload) {
        state.grouped = payload;
    },
    [FETCH_TRAINER](state, payload) {
        state.trainer = payload;
    },
    [FETCH_TRAINER_COURSE_MONTHLY_STATS](state, payload) {
        state.trainer_course_monthly_stats = payload;
    },
    [POST_TRAINER](state, payload) {
        state.created = payload;
    },
    [PATCH_TRAINER](state, payload) {
        state.patched = payload;
    },
    [DELETE_TRAINER](state, payload) {
        state.deleted = payload;
    },
    [WECHAT_UNBIND_TRAINER](state, payload) {
        state.patched = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer/mutations.js